import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const tournamentLeaderboard = createAsyncThunk(
  "tournamentLeaderboard/tournamentLeaderboard",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post("tournament/leaderboard", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const tournamentLeaderboardSlice = createSlice({
  name: "tournamentLeaderboard",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(tournamentLeaderboard.pending, (state) => {
        state.loading = true;
      })
      .addCase(tournamentLeaderboard.fulfilled, (state, action) => {
          
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(tournamentLeaderboard.rejected, (state, action) => {
        
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default tournamentLeaderboardSlice.reducer;
